exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#worldView {\r\n  width: 100%;\r\n  height: 900px;\r\n  background-color:#1132a3;\r\n}\r\n\r\n.map-marker {\r\n    /* adjusting for the marker dimensions\r\n    so that it is centered on coordinates */\r\n    margin-left: -8px;\r\n    margin-top: -8px;\r\n}\r\n.map-marker.map-clickable {\r\n    cursor: -webkit-grab ;\r\n    cursor: grab ;\r\n}\r\n.pulse {\r\n    width: 10px;\r\n    height: 10px;\r\n    border: 1px solid green;\r\n    border-radius: 30px;\r\n    background-color: green;\r\n    z-index: 10;\r\n    position: absolute;\r\n  }\r\n.map-marker .dot {\r\n    border: 10px solid #ffffff;\r\n    background: transparent;\r\n    border-radius: 60px;\r\n    height: 50px;\r\n    width: 50px;\r\n    animation: pulse 3s ease-out;\r\n    animation-iteration-count: infinite;\r\n    position: absolute;\r\n    top: -28px;\r\n    left: -29px;\r\n    z-index: 1;\r\n    opacity: 0;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/features/dashboard/world-view-container/world-view-container.component.css
// module id = ../../../../../src/app/features/dashboard/world-view-container/world-view-container.component.css
// module chunks = main